import Router from './routes';
import ThemeProvider from './theme';
import ScrollToTop from './components/ScrollToTop';
import { ErrorBoundary } from './components/ErrorBoundary';
import { useEffect } from 'react';
import axios from 'axios';
import { UploadProvider } from './context/uploadContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function App() {
  useEffect(() => {
    axios.defaults.baseURL = process.env.REACT_APP_LIVE_URL;
  }, [])
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <ScrollToTop />
        <ToastContainer />
        <UploadProvider authEndpoint={`${process.env.REACT_APP_LIVE_URL}/lecture/upload-request`}>
          <Router />
        </UploadProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}
